import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureName = ({
  featureDisplayName,
  isBeta,
  textStyles
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    as: "span",
    display: "inline-flex",
    alignItems: "center",
    gap: "100",
    flexWrap: "wrap",
    children: [/*#__PURE__*/_jsx(Text, Object.assign({}, textStyles, {
      children: featureDisplayName
    })), isBeta && /*#__PURE__*/_jsx(Badge, {
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "feature-monetization.featureTable.beta"
      })
    })]
  });
};